/* BakeBarn motion: counters, scroll story, stacking value cards.
   Ticker, hero reveal and hover effects are pure CSS (bb-theme.css).
   Runs only when Theme settings > BakeBarn brand > animations is on
   (html.bb-motion) and the visitor has not asked for reduced motion.
   Re-initialises when sections are edited in the theme editor. */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  function motionOK(el) {
    return !RM.matches && document.documentElement.classList.contains('bb-motion') &&
      (!el || el.getAttribute('data-bb-anim') !== 'false');
  }
  function clamp(v, a, b) { return Math.min(b === undefined ? 1 : b, Math.max(a || 0, v)); }
  function mix(a, b, t) {
    var A = a.match(/\w\w/g).map(function (h) { return parseInt(h, 16); });
    var B = b.match(/\w\w/g).map(function (h) { return parseInt(h, 16); });
    return '#' + A.map(function (v, i) { return Math.round(v + (B[i] - v) * t).toString(16).padStart(2, '0'); }).join('');
  }
  var stories = [], stacks = [], raf = 0;

  /* ---------- counters ---------- */
  function initCounters(root) {
    root.querySelectorAll('[data-bb-count]').forEach(function (el) {
      if (el.__bb) return; el.__bb = true;
      var raw = el.getAttribute('data-bb-count'), to = parseFloat(raw) || 0;
      var dec = (raw.split('.')[1] || '').length, num = el.querySelector('.bb-count__v');
      var sec = el.closest('.bb-sec'), dur = parseInt((sec && sec.getAttribute('data-bb-dur')) || 1500, 10);
      if (!num || !motionOK(sec)) return;
      num.textContent = (0).toFixed(dec);
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        var t0 = performance.now();
        (function step(t) {
          var k = Math.min(1, (t - t0) / dur);
          num.textContent = (to * (1 - Math.pow(1 - k, 3))).toFixed(dec);
          if (k < 1) requestAnimationFrame(step); else num.textContent = raw;
        })(t0);
      }, { threshold: 0.5 });
      io.observe(el);
    });
  }

  /* ---------- scroll story ---------- */
  function initStory(sec) {
    var mp = sec.querySelector('[data-bb-mask]');
    var st = {
      sec: sec, mp: mp, L: mp ? mp.getTotalLength() : 0,
      parch: sec.querySelector('[data-bb-parch]'), chain: sec.querySelector('[data-bb-chain]'),
      steam: sec.querySelector('[data-bb-steam]'), c1: sec.querySelectorAll('[data-bb-crust1]'), c2: sec.querySelectorAll('[data-bb-crust2]'),
      steps: sec.querySelectorAll('.bb-story__step'), bar: sec.querySelector('.bb-story__bar span'), track: sec.querySelector('.bb-story__track')
    };
    if (!motionOK(sec)) {
      sec.classList.add('bb-static');
      st.steps.forEach(function (s) { s.classList.add('is-active'); });
      return;
    }
    sec.classList.remove('bb-static');
    if (mp) mp.style.strokeDasharray = st.L;
    stories.push(st); updateStory(st);
  }
  function updateStory(st) {
    var r = st.track.getBoundingClientRect(), vh = window.innerHeight;
    var p = clamp(-r.top / Math.max(1, r.height - vh));
    var a = clamp(p / 0.18), d = clamp((p - 0.2) / 0.48), b = clamp((p - 0.72) / 0.18);
    if (st.parch) { st.parch.style.transform = 'scale(' + (0.35 + 0.65 * (1 - Math.pow(1 - a, 3))) + ')'; st.parch.style.opacity = clamp(p / 0.1); }
    if (st.mp) { st.chain.style.opacity = d > 0 ? 1 : 0; st.mp.style.strokeDashoffset = st.L * (1 - d); }
    st.c1.forEach(function (el) { el.style.fill = mix('#E9CC98', '#C98A3E', b); });
    st.c2.forEach(function (el) { el.style.fill = mix('#DDB67E', '#B8752F', b); });
    if (st.steam) st.steam.style.opacity = b;
    var n = st.steps.length, i = Math.min(n - 1, Math.floor(p * n * 0.999));
    st.steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
    if (st.bar) st.bar.style.transform = 'scaleX(' + p + ')';
  }

  /* ---------- stacking value cards ---------- */
  function initStack(sec) {
    if (!motionOK(sec) || sec.getAttribute('data-bb-stack') !== 'true') return;
    stacks.push({ sec: sec, cards: Array.prototype.slice.call(sec.querySelectorAll('.bb-vcard')) });
  }
  function updateStack(s) {
    var desk = window.innerWidth >= 750, vh = window.innerHeight;
    s.cards.forEach(function (c, i) {
      var n = s.cards[i + 1];
      if (!n || !desk) { c.style.transform = ''; c.style.filter = ''; return; }
      var t = n.getBoundingClientRect().top, end = parseFloat(getComputedStyle(n).top) || 0;
      var p = clamp((vh - t) / Math.max(1, vh - end));
      c.style.transform = 'scale(' + (1 - 0.09 * p).toFixed(4) + ')';
      c.style.filter = 'brightness(' + (1 - 0.3 * p).toFixed(3) + ')';
    });
  }

  /* ---------- sticky add to cart (not a motion effect, always on) ---------- */
  function initSatc(root) {
    root.querySelectorAll('[data-bb-satc]').forEach(function (bar) {
      if (bar.__bb) return; bar.__bb = true;
      var target = document.querySelector('.product-form__submit');
      if (!target) { bar.classList.add('is-visible'); return; }
      new IntersectionObserver(function (es) {
        var e = es[0]; bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(target);
    });
  }

  function tick() { raf = 0; stories.forEach(updateStory); stacks.forEach(updateStack); }
  function schedule() { if (!raf) raf = requestAnimationFrame(tick); }

  function init(root) {
    root = root || document;
    initCounters(root);
    initSatc(root);
    root.querySelectorAll('.bb-story').forEach(initStory);
    root.querySelectorAll('.bb-values').forEach(initStack);
    schedule();
  }
  function cleanup(root) {
    stories = stories.filter(function (s) { return !root.contains(s.sec); });
    stacks = stacks.filter(function (s) { return !root.contains(s.sec); });
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', function (e) { cleanup(e.target); init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { cleanup(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
